/** 展示格式化：时间、金额、编号、SLA 计时（前端展示，SLA 以后端为准） */

function toDate(value?: string | number | Date | null): Date | null {
  if (value === null || value === undefined || value === '') return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

function pad(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

export function formatDateTime(value?: string | number | Date | null, fallback = '—'): string {
  const d = toDate(value);
  if (!d) return fallback;
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(
    d.getMinutes(),
  )}:${pad(d.getSeconds())}`;
}

/** 宽表用短格式：09-07 14:00 */
export function formatShortDateTime(value?: string | number | Date | null, fallback = '—'): string {
  const d = toDate(value);
  if (!d) return fallback;
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function formatDate(value?: string | number | Date | null, fallback = '—'): string {
  const d = toDate(value);
  if (!d) return fallback;
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function formatTime(value?: string | number | Date | null, fallback = '—'): string {
  const d = toDate(value);
  if (!d) return fallback;
  return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

export function formatMoney(value?: number | string | null, fallback = '—'): string {
  if (value === null || value === undefined || value === '') return fallback;
  const n = Number(value);
  if (Number.isNaN(n)) return fallback;
  return `¥${n.toLocaleString('zh-CN', { minimumFractionDigits: n % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 })}`;
}

export function formatNumber(value?: number | string | null, fallback = '—'): string {
  if (value === null || value === undefined || value === '') return fallback;
  const n = Number(value);
  return Number.isNaN(n) ? fallback : n.toLocaleString('zh-CN');
}

export function formatPercent(value?: number | string | null, digits = 1, fallback = '—'): string {
  if (value === null || value === undefined || value === '') return fallback;
  const n = Number(value);
  return Number.isNaN(n) ? fallback : `${n.toFixed(digits)}%`;
}

export interface SlaState {
  /** 剩余毫秒；已超时为负 */
  remainingMs: number;
  text: string;
  /** danger: 已超时或 <1h（原型：SLA<1h 脉冲） */
  level: 'safe' | 'soon' | 'over';
}

/** SLA 倒计时：录入→分配 2h、分配→接单 60min、公区领取 2h */
export function slaCountdown(deadline?: string | number | Date | null, now = Date.now()): SlaState | null {
  const d = toDate(deadline);
  if (!d) return null;
  const remainingMs = d.getTime() - now;
  const abs = Math.abs(remainingMs);
  const hours = Math.floor(abs / 3600000);
  const minutes = Math.floor((abs % 3600000) / 60000);
  const body = hours > 0 ? `${hours}h${pad(minutes)}m` : `${minutes}m`;
  if (remainingMs < 0) {
    return { remainingMs, text: `超时 ${body}`, level: 'over' };
  }
  if (remainingMs < 3600000) {
    return { remainingMs, text: `剩 ${body}`, level: 'soon' };
  }
  return { remainingMs, text: `剩 ${body}`, level: 'safe' };
}

/** 入池等待时长（公区 FIFO / >4h 红警） */
export function elapsedText(from?: string | number | Date | null, now = Date.now()): string {
  const d = toDate(from);
  if (!d) return '—';
  const ms = Math.max(0, now - d.getTime());
  const hours = Math.floor(ms / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  return hours > 0 ? `${hours}h${pad(minutes)}m` : `${minutes}m`;
}

/** 编号规范校验（服务端统一生成，前端仅校验/展示）：订单 D-MMDD-NNN */
export const ORDER_NO_PATTERN = /^D-\d{4}-\d{3}$/;
export const BATCH_NO_PATTERN = /^B-\d{4}$/;
export const BILL_NO_PATTERN = /^SB-\d{4}-\d{3}-\d$/;
export const SETTLE_BATCH_PATTERN = /^ST-\d{4}W\d{2}$/;
export const ALERT_TICKET_PATTERN = /^AL-\d{4}-\d{2}$/;
export const COURIER_NO_PATTERN = /^DL-\d{4}$/;
export const CARRIER_JOB_NO_PATTERN = /^YS-CD-\d{5}$/;
export const CALL_NO_PATTERN = /^CALL-\d{5}$/;

/** 手机号有效性（录单四项校验之一，前端预校验，后端权威） */
export const MOBILE_PATTERN = /^1[3-9]\d{9}$/;

export function isValidMobile(value: string): boolean {
  return MOBILE_PATTERN.test(String(value).replace(/\s|-/g, ''));
}
